module.exports = __webpack_public_path__ + "static/assets/62b6b4691fe30d6b294cf9b905ccc96b.svg";